import { Component, computed, inject } from '@angular/core';
import { UserHelperService } from './user-helper.service';
import { ActivatedRoute } from '@angular/router';
import { AppRouteService } from 'ets-fe-ng-sdk';
import { UtilityService } from '@Services/utility.service';

@Component({
  imports: [],
  template: ' ',
})
export class UserHelperModuleComponent {
  readonly service = inject(UserHelperService);
  readonly routeService = inject(AppRouteService);
  readonly route = inject(ActivatedRoute);
  readonly uS = inject(UtilityService);

  readonly currentRoute = computed(() => this.routeService.currentRouteSignal());
}
